import { message } from 'antd';
import { client } from '../../../actions';
import { authHeader } from '../../../helpers/auth-header';

const getDocumentDefaultFilter = async () => {
  try {
    const { data: defaultFilter } = await client.get('/Filter/default', {
      headers: authHeader(),
      params: { type: 'DOCS' },
    });

    return defaultFilter;
  } catch (err) {
    message.error('Произошла ошибка при загрузке фильтра по умолчанию');
    console.error(err);
    return;
  }
};

export default getDocumentDefaultFilter;